import(/* webpackMode: "eager", webpackExports: ["AuditConfigClient"] */ "/vercel/path0/web/app/(app)/audit/new/audit-config-client.tsx");
